import { render, staticRenderFns } from "./GynecoHistoryTemplate.vue?vue&type=template&id=23ede733"
import script from "./GynecoHistoryTemplate.vue?vue&type=script&lang=js"
export * from "./GynecoHistoryTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports